export default [
    {
        path: "/training/ret/list",
        component: () => import("@/App/Training/Ret/Components/List.vue"),
        name: "training-ret-list",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/training/ret/detail-list",
        component: () => import("@/App/Training/Ret/Components/DetailList.vue"),
        name: "training-ret-detail-list",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/training/ret/detail",
        component: () => import("@/App/Training/Ret/Components/DetailCreate.vue"),
        name: "training-ret-detail",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/training/ret/detail-edit/:id",
        component: () => import("@/App/Training/Ret/Components/DetailEdit.vue"),
        name: "training-ret-detail-edit",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/training/ret/result",
        component: () => import("@/App/Training/Ret/Components/Result.vue"),
        name: "training-ret-result",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/training/ret/create",
        component: () => import("@/App/Training/Ret/Components/Create.vue"),
        name: "training-ret-create",
        meta: {
            requiresAuth: true,
        },
    },
];
